import cn from "classnames";
import { useTranslation } from "react-i18next";

import { Typography } from "shared/ui/components/Typography";

import { LoanRateChart } from "./components/LoanRateChart";
import { TaxSavingsChart } from "./components/TaxSavingsChart";
import { LoanProfitChart } from "./components/LoanProfitChart";
import { InvestmentAccChart } from "./components/InvestmentAccChart";
import { InvestmetAnalysisChart } from "./components/InvestmetAnalysisChart";
import { InvestmentAnalysisChart } from "./components/InvestmentAnalysisChart";
import { TaxSavingsAndProfitChart } from "./components/TaxSavingsAndProfitChart";

import styles from "./Conclusions.module.scss";

const _renderInfoPopover = ({ info }: { info: any }) => {
  return (
    <div className={styles.popover}>
      <Typography variant="bodyS" weight="light">
        {info?.section1}
      </Typography>
      {info?.section2 && (
        <Typography
          variant="bodyS"
          weight="light"
          className={styles.popoverSection}
        >
          {info?.section2}
        </Typography>
      )}
    </div>
  );
};

const Conclusions = ({
  className,
  activePosition,
  irrChartsData,
  roiChartsData,
  loanRateChartData,
  loanProfitChartData,
  taxSavingsConclusion,
  userScenarioResult,
  investmentAccConclusion,
  earlySaleProfitConclusion,
  proCalculationCharts,
  investorCashFlowConclusion,
}: any) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.chartsWrapper, className)}>
      <div className={styles.chartItems}>
        {proCalculationCharts?.investmetAnalysisChart && (
          <InvestmetAnalysisChart
            variant={userScenarioResult}
            earlySaleProfitConclusion={earlySaleProfitConclusion}
          />
        )}
        {proCalculationCharts?.investmentAccChart && (
          <InvestmentAccChart
            variant={userScenarioResult}
            investmentAccConclusion={investmentAccConclusion}
          />
        )}
        <LoanProfitChart
          title={t("loan_conclusion.monthly_payment.title")}
          labelTextColor="#131618"
          variant={loanProfitChartData.overwriteVariant || userScenarioResult}
          descriptionVariant={
            loanProfitChartData.overwriteVariant || userScenarioResult
          }
          caption={loanProfitChartData.caption}
          details={loanProfitChartData.details}
          price={loanProfitChartData.price}
          description={loanProfitChartData?.description || ""}
          data={loanProfitChartData.chartData}
          infoPopover={_renderInfoPopover({ info: loanProfitChartData.info })}
        />
        <LoanRateChart
          title={t("loan_conclusion.loan_rate.title")}
          labelTextColor="#ffffff"
          variant={loanRateChartData.overwriteVariant || userScenarioResult}
          price={loanRateChartData.price}
          caption={loanRateChartData.caption}
          details={loanRateChartData.details}
          description={loanRateChartData?.description || ""}
          data={loanRateChartData.chartData}
          infoPopover={_renderInfoPopover({ info: loanRateChartData.info })}
        />
      </div>
      <div className={styles.chartItems}>
        {proCalculationCharts?.taxSavingsAndProfitChart && (
          <TaxSavingsAndProfitChart
            variant={userScenarioResult}
            investorCashFlowConclusion={investorCashFlowConclusion}
            activePosition={activePosition}
          />
        )}

        <InvestmentAnalysisChart
          variant={userScenarioResult}
          title={"Eigenkapitalrendite \n (IRR-Methode)"}
          price={irrChartsData.price}
          description={irrChartsData.description}
          data={irrChartsData.chartData}
          caption={irrChartsData.caption}
          details={irrChartsData.details}
          info={irrChartsData.info}
        />

        {proCalculationCharts?.taxSavingsChart && (
          <TaxSavingsChart
            variant={userScenarioResult}
            taxSavingsConclusion={taxSavingsConclusion}
          />
        )}
        <InvestmentAnalysisChart
          variant={userScenarioResult}
          title={"Gesamtrendite ROI"}
          price={roiChartsData.price}
          description={roiChartsData.description}
          data={roiChartsData.chartData}
          caption={roiChartsData.caption}
          details={roiChartsData.details}
          info={roiChartsData.info}
        />
      </div>
    </div>
  );
};

export default Conclusions;
